import { resolve } from '../../../init/store';
import { hiddenBreadcrumbs } from './hidden-breadcrumbs';

export class Controller {

    /** @ngInject */
    constructor($rootScope) {
        this.$rootScope = $rootScope;
    }

    $onInit() {
    	this.resolve = resolve;
        this.accountRole = resolve.currentCompany;
        this.companyStatus=this.accountRole.companyStatus;
        this.colorClass= this.companyStatus==='ACTIVE'?'' :'sp_colorRedTex';
        
    }

    visibleBreadcrumbs() {
        return (this.$rootScope.breadcrumbs || [])
            .filter(b => !hiddenBreadcrumbs.includes(b.name));
    }

    child() {
        return this.visibleBreadcrumbs().slice(-1)[0];
    }

    parents() {
        return this.visibleBreadcrumbs().slice(0, -1);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-header/sp-breadcrumbs/sp-breadcrumbs.controller.js